import axios from 'axios';
import {DataCache} from '../common/data-cache.js';

let cache = {};

/** @return {Promise<Cart>} */
export function getCart(cartId, token) {
  const istApiUrl = globalThis.storeVariables.eCommUrl;
  const apiUrl = `${istApiUrl}/carts/${cartId}`;
  return axios({
    url: apiUrl,
    method: 'get',
    headers: {
      Authorization: token || 'anonymous',
    },
    withCredentials: true,
    responseType: 'json',
  });
}

/** @return {DataCache} */
export function getCartCache(cartId, token) {
  const cacheId = cartId + '_' + token;
  cache[cacheId]
    = cache[cacheId]
      || new DataCache(function () {
        return getCart(cartId, token);
      });

  return cache[cacheId];
}
